export default async function GetUnitMaster() {
    let url = window.RealestateService+  `/api/Unit/GetUnitMaster`
    let head = {
         "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}